import React, { FC } from 'react';
import styled from 'styled-components';
import { SystemIconButton } from '../../../../Icon/SystemIconButton';
import { Typography } from '../../../../Typography/Typography';
import Drawer from '../../../../Drawer/Drawer';
import { useDataTableQuickReportsContext } from '../../../utils/DataTableQuickReportsContext';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';
import { DataTableQuickReportsContent } from './DataTableQuickReportsContent';

export const DataTableQuickReports: FC<React.PropsWithChildren<unknown>> = () => {
  const { intl } = useIntlUds();

  const { isQuickReportDrawerOpen, setQuickReportDrawer } = useDataTableQuickReportsContext();

  return (
    <Drawer
      dataTest="data-table-quick-reports-drawer"
      open={isQuickReportDrawerOpen}
      anchor="right"
      variant="temporary"
      onClose={() => setQuickReportDrawer(false)}
    >
      <StyledPanel>
        <StyledHeader>
          <Typography variant="h3" className="drawer-title">
            {intl.DataTable.QuickViews.quickViews}
          </Typography>
          <SystemIconButton
            dataTest="close-quick-report-drawer"
            iconName="close"
            onClick={() => setQuickReportDrawer(false)}
          />
        </StyledHeader>
        <DataTableQuickReportsContent />
      </StyledPanel>
    </Drawer>
  );
};

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacingSize.m};
  padding-bottom: ${({ theme }) => theme.spacingSize.l};
`;

const StyledPanel = styled.div`
  padding: ${({ theme }) => theme.spacingSize.xl};
  background-color: ${(props) => props.theme.colorSurface};
  color: ${(props) => props.theme.colorOnSurface};
  height: 100vh;
  min-width: 400px;
  max-width: 400px;
`;
